export const countryNames = {
  CA: 'country.name.canada',
  IE: 'country.name.ireland',
  GB: 'country.name.united-kingdom',
  US: 'country.name.united-states'
} as const
